import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListEmspUserLastNameCell } from './emsp-bo-rfid-badge-order-list-emsp-user-last-name.cell';
import { EmspBoRfidBadgeOrderListEmspUserLastNameHeader } from './emsp-bo-rfid-badge-order-list-emsp-user-last-name.header';

export const EmspBoRfidBadgeOrderListEmspUserLastNameColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['emspUser']['lastName']
> = {
  id: 'emspUserLastName',
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListEmspUserLastNameHeader,
  cell: EmspBoRfidBadgeOrderListEmspUserLastNameCell,
};
